<template>
  <div class="notifications-page">
    <h1>Notifications</h1>
    <v-radio-group v-model="sendType" row>
      <v-radio label="Send to All Users" value="all" />
      <v-radio label="Send to Specific User" value="user" />
      <v-radio label="Send to Group" value="group" />
    </v-radio-group>

    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-text-field v-model="title" label="Title" :rules="[v => !!v || 'Title is required']" required />
      <v-textarea v-model="message" label="Message" :rules="[v => !!v || 'Message is required']" required />

      <v-autocomplete
        v-if="sendType === 'user'"
        v-model="selectedUser"
        :items="users"
        item-text="name"
        item-value="id"
        label="Select User"
        :rules="[v => !!v || 'User is required']"
        clearable
        required
      ></v-autocomplete>

      <div v-if="sendType === 'group'">
        <v-select
          v-model="selectedRole"
          :items="roles"
          item-text="text"
          item-value="value"
          label="Select Role"
          :rules="[v => !!v || 'Role is required']"
          required
        ></v-select>

        <v-autocomplete
          v-model="selectedSchool"
          :items="schools"
          item-text="name"
          item-value="id"
          label="Select School"
          :rules="[v => !!v || 'School is required']"
          clearable
          required
        ></v-autocomplete>
      </div>

      <v-btn color="primary" @click="handleSend" :loading="loading" :disabled="!formValid">
        Send Notification
      </v-btn>
    </v-form>

    <v-alert v-if="responseMsg" :type="responseSuccess ? 'success' : 'error'" class="mt-4">
      {{ responseMsg }}
    </v-alert>
  </div>
</template>

<script>
import NotificationService from '@/services/NotificationService'

export default {
  name: 'NotificationsPage',
  data() {
    return {
      sendType: 'all',
      title: '',
      message: '',
      loading: false,
      responseMsg: '',
      responseSuccess: false,
      formValid: false,
      users: [],
      selectedUser: null,
      roles: [
        { value: 3, text: 'driver' },
        { value: 4, text: 'parent' },
        { value: 5, text: 'guardian' },
      ],
      selectedRole: null,
      schools: [],
      selectedSchool: null,
    }
  },
  created() {
    this.fetchUsers();
    this.fetchSchools();
  },
  methods: {
    async fetchUsers() {
      try {
        const res = await NotificationService.getusers();
        this.users = res.data || [];
      } catch (e) {
        console.error('Failed to fetch users', e);
      }
    },
    async fetchSchools() {
      try {
        const res = await NotificationService.getusers({ role_id: 2 });
        this.schools = res.data || [];
      } catch (e) {
        console.error('Failed to fetch schools', e);
      }
    },
    async handleSend() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      this.responseMsg = '';
      try {
        let res;
        if (this.sendType === 'all') {
          res = await NotificationService.broadcastToAll({ title: this.title, message: this.message });
        } else if (this.sendType === 'user') {
          res = await NotificationService.sendToUser({ user_id: this.selectedUser, title: this.title, message: this.message });
        } else if (this.sendType === 'group') {
          res = await NotificationService.sendToGroup({ role_id: this.selectedRole, school_id: this.selectedSchool, title: this.title, message: this.message });
        }
        if (res && res.data && res.data.success) {
          this.responseMsg = res.data.message;
          this.responseSuccess = true;
        } else {
          this.responseMsg = (res && res.data && res.data.message) || 'Failed to send notification.';
          this.responseSuccess = false;
        }
      } catch (e) {
        this.responseMsg = e.response?.data?.message || 'Error sending notification.';
        this.responseSuccess = false;
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>

<style scoped>
.notifications-page {
  padding: 24px;
}
</style>
